import {
  Breakpoint,
  BreakpointName,
  BREAKPOINTS,
} from '../../utils/breakpoints';

export type SizeValue = number | string;
export type RequiredResponsiveSizes = { _: SizeValue } & Partial<
  Record<BreakpointName, SizeValue>
>;

export const generateSizesAttribute = (
  sizes: RequiredResponsiveSizes,
  // Allow passing breakpoints for testing stability regardless of import order
  breakpoints: Breakpoint[] = BREAKPOINTS,
): string => {
  const parts: string[] = [];

  // Sort breakpoints descending by min width (largest first) to ensure correct CSS evaluation order
  // (Browser picks the first matching media condition)
  const sortedBreakpoints = [...breakpoints].sort((a, b) => {
    // Handle null (base _) as smallest (though we skip _ in the loop, good to be robust)
    const valA = a.min ?? -1;
    const valB = b.min ?? -1;
    return valB - valA;
  });

  for (const bp of sortedBreakpoints) {
    if (bp.name === '_') continue;

    const val = sizes[bp.name];
    if (val !== undefined) {
      const sizeStr = typeof val === 'number' ? `${val}px` : val;
      parts.push(`(min-width: ${bp.min}px) ${sizeStr}`);
    }
  }

  // Fallback
  const fallbackVal = sizes._;
  const fallbackStr =
    typeof fallbackVal === 'number' ? `${fallbackVal}px` : fallbackVal;
  parts.push(fallbackStr);

  return parts.join(', ');
};
